export default __webpack_public_path__ + "images/74d09d90e7daec2320b47050a28e0650-music.jpg";